module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/jonathan-559e5abb3518d58d57b1f1574350429d.jpg";